import { Employee } from '../types/employee.types'

export function employeeArrayTransform(employees: Employee[]): Employee[] {
  const transformedEmployees = [...employees]
  if (transformedEmployees.length === 9) {
    let temp = transformedEmployees[1]
    transformedEmployees[1] = transformedEmployees[3]
    transformedEmployees[3] = temp

    temp = transformedEmployees[2]
    transformedEmployees[2] = transformedEmployees[6]
    transformedEmployees[6] = temp

    temp = transformedEmployees[5]
    transformedEmployees[5] = transformedEmployees[7]
    transformedEmployees[7] = temp
  }
  return transformedEmployees
}
